import FJAIVideoGeneratorLeft from '../view/FJAIVideoGeneratorLeft';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback, useEffect } from 'react';
import FJActionAIVideoGenerator from '../../../../redux/action/FJActionAIVideoGenerator.js';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon.js';
import FJActionAiHistoryCommon from '../../../../redux/action/FJActionAiHistoryCommon.js';
import FJActionModal from '../../../../redux/action/FJActionModal.js';
import FJUtil from '../../../../util/FJUtil.js';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';
import { setSliceAudioActive } from '../../../../redux/slices/FJSliceAIVideoGenerator.js';

const FJAIVideoGeneratorLeftContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const currentRatio = useSelector(state => state.AIVideoGenerator.currentRatio);
    const currentQuality = useSelector(state => state.AIVideoGenerator.currentQuality);
    const currentDuration = useSelector(state => state.AIVideoGenerator.currentDuration);
    const tabIndex = useSelector(state => state.AIVideoGenerator.tabIndex);
    const originImage = useSelector(state => state.AIVideoGenerator.originImage);
    const tvTextValue = useSelector(state => state.AIVideoGenerator.tvTextValue);
    const ivTextValue = useSelector(state => state.AIVideoGenerator.ivTextValue);
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const uploadStatus = useSelector(state => state.AIVideoGenerator.uploadStatus);
    const audioActive = useSelector(state => state.AIVideoGenerator.audioActive);

    const taskStatus = useSelector(state => state.common.taskStatus);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const creditNumber = useSelector(state => state.common.creditNumber);

    const ivFreeNum = useSelector(state => state.AIVideoGenerator.ivFreeNum);
    const tvFreeNum = useSelector(state => state.AIVideoGenerator.tvFreeNum);

    const totalCredit = useSelector(state => {
        const totalCredit = state.AIVideoGenerator.totalCredit;
        const aiSfxTotalCredit = state.AIVideoGenerator.aiSfxTotalCredit;
        return totalCredit + aiSfxTotalCredit;
    });

    const freeNumCreation = tabIndex === 1 ? ivFreeNum : tvFreeNum;

    useEffect(() => {
        window.addEventListener('storage', function (event) {
            if (event.key === 'communicationKey') {
                try {
                    dispatch(FJActionAiHistoryCommon.initAiTextToImageHistoryList(true));
                    dispatch(FJActionAiHistoryCommon.initAiImageToImageHistoryList(true));
                } catch (e) {
                    console.log(e);
                }
            }
        });
    }, []);

    useEffect(() => {
        dispatch(FJActionAIVideoGenerator.initAIVideoGeneratorAction());
    }, [dispatch]);

    const setIsDraggingFile = useCallback(
        value => {
            dispatch(setSliceIsDraggingFileAction(value));
        },
        [dispatch],
    );

    const changeRatio = useCallback(
        ratio => {
            dispatch(FJActionAIVideoGenerator.changeRatioAction(ratio));
        },
        [dispatch],
    );

    const onChangeQuality = useCallback(
        quality => {
            if (quality === 2 && FJUtil.isLogin()) {
                if (totalCredit > creditNumber) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    dispatch(FJActionAIVideoGenerator.changeQualityAction(1));
                    return;
                }
            }
            dispatch(FJActionAIVideoGenerator.changeQualityAction(quality));
        },
        [dispatch, creditNumber, totalCredit],
    );

    const onChangeDuration = useCallback(
        duration => {
            if (duration === 10) {
                if (totalCredit > creditNumber && FJUtil.isLogin()) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    dispatch(FJActionAIVideoGenerator.changeDurationAction(5));
                    return;
                }
            }
            dispatch(FJActionAIVideoGenerator.changeDurationAction(duration));
        },
        [dispatch, totalCredit, creditNumber],
    );

    const onChangeTabIndex = useCallback(
        index => {
            dispatch(FJActionAIVideoGenerator.changeTabIndexAction(index));
        },
        [dispatch],
    );

    const onTextValueChange = useCallback(
        value => {
            dispatch(FJActionAIVideoGenerator.changeTextValueAction(value));
        },
        [dispatch],
    );

    const uploadFile = useCallback(
        file => {
            dispatch(FJActionAIVideoGenerator.uploadFileAction(file));
        },
        [dispatch],
    );

    const onGenerate = useCallback(() => {
        dispatch(FJActionAIVideoGenerator.onGenerateAction());
    }, [dispatch]);

    const getInspire = useCallback(() => {
        dispatch(FJActionAIVideoGenerator.getInspireAction());
    }, [dispatch]);

    const showAIImageHistoryList = useCallback(() => {
        dispatch(FJActionAiHistoryCommon.showAIImageHistoryListAction());
    }, [dispatch]);

    const onFileDelete = useCallback(() => {
        dispatch(FJActionAIVideoGenerator.clearFileAction());
    }, [dispatch]);

    const _openMediaLibrary = () => {
        dispatch(FJActionEditPage.openMediaLibraryAction());
    };

    const onChangeAudioActive = useCallback(
        value => {
            dispatch(setSliceAudioActive(value));
        },
        [dispatch],
    );

    return (
        <FJAIVideoGeneratorLeft
            tabIndex={tabIndex}
            currentRatio={currentRatio}
            changeRatio={changeRatio}
            currentQuality={currentQuality}
            currentDuration={currentDuration}
            totalCredit={totalCredit}
            onChangeQuality={onChangeQuality}
            onChangeDuration={onChangeDuration}
            onChangeTabIndex={onChangeTabIndex}
            originImage={originImage}
            textValue={tabIndex === 1 ? ivTextValue : tvTextValue}
            onTextValueChange={onTextValueChange}
            uploadFile={uploadFile}
            isDraggingFile={isDraggingFile}
            setIsDraggingFile={setIsDraggingFile}
            uploadStatus={uploadStatus}
            onGenerate={onGenerate}
            getInspire={getInspire}
            showAIImageHistoryList={showAIImageHistoryList}
            taskStatus={taskStatus}
            isProjectLoading={isProjectLoading}
            freeNumCreation={freeNumCreation}
            creditNumber={creditNumber}
            onFileDelete={onFileDelete}
            openMediaLibrary={_openMediaLibrary}
            audioActive={audioActive}
            onChangeAudioActive={onChangeAudioActive}
        />
    );
};
export default FJAIVideoGeneratorLeftContainer;
